<template>
  <div class="statisDiv" id="vehicleModify">
    <div style="position: fixed;width: 100vw;background: #f4f5f6;z-index: 99;">
      <div class="top-cont">
        <van-tabs
          v-model="active"
          style="flex: 1;"
          @click="clickTimeTab"
          :class="timeRange.length > 0 ? 'hideTabActive' : ''"
        >
          <van-tab title="昨天" name="0"> </van-tab>
          <van-tab title="今天" name="1"> </van-tab>
        </van-tabs>
        <div class="time" @click="showCalendar = true">
          <div
            v-if="timeRange.length === 0"
            style="display: flex;align-items: inherit;"
          >
            <van-icon name="clock-o" />选择指定日期
          </div>
          <div v-else>{{ timeRange.join("至") }}</div>
        </div>
      </div>
      <!-- <van-calendar
        v-model="showCalendar"
        color="#009967"
        type="range"
        @confirm="onConfirm"
        row-height="58"
        :show-title="false"
        :round="false"
      />  -->
      <van-calendar
        id="vehicleModify"
        v-model="showCalendar"
        color="#009967"
        type="range"
        @confirm="onConfirm"
        :show-confirm="false"
        :show-title="false"
        row-height="58"
        :round="false"
        position="right"
        :allow-same-day="true"
        :formatter="formatter"
        :min-date="minDate"
        :max-date="maxDate"
      >
        <template slot="footer">
          <div class="calendar-cont">
            <div style="flex: 1;" @click="setTime(0)">最近一周</div>
            <div style="flex: 1;" @click="setTime(1)">最近一个月</div>
            <div style="flex: 1;" @click="setTime(2)">最近一年</div>
          </div>
        </template>
      </van-calendar>
      <div class="cont1">
        <div class="blk">
          <div @click="pickerShow1 = true" class="left">
            {{ comValue }}
          </div>
          <div class="right" @click="pickerShow1 = true">
            <van-icon name="arrow-down" color="#b2b2b2" />
          </div>
        </div>
        <div class="blk">
          <div @click="pickerShow2 = true" class="left">
            {{ logisValue }}
          </div>
          <div class="right" @click="pickerShow2 = true">
            <van-icon name="arrow-down" color="#b2b2b2" />
          </div>
        </div>
      </div>
    </div>
    <van-popup v-model="pickerShow1" position="bottom">
      <van-picker
        show-toolbar
        :columns="comColumns"
        @confirm="onConfirmCom"
        @cancel="pickerShow1 = false"
      />
    </van-popup>
    <van-popup v-model="pickerShow2" position="bottom">
      <van-picker
        show-toolbar
        :columns="logisColumns"
        @confirm="onConfirmLogis"
        @cancel="pickerShow12 = false"
      />
    </van-popup>
    <div style="height: 111px;background-color: #f4f5f6;"></div>

    <van-collapse
      v-model="activeNames"
      accordion
      @change="changeCollapse"
      id="static"
    >
      <van-collapse-item
        :name="index"
        v-for="(item, index) in vehicleList"
        :key="index"
        :id="'collapse' + index"
      >
        <template #title>
          <div class="title">
            <!-- <van-icon
              name="arrow"
              :class="rotate ? 'second' : 'first'"
              style="margin-right: 5px;"
            /> -->
            <span class="title-left-span">{{ logisValue.split("(")[0] }}</span>
            <div class="title-left">
              {{ item.license_plate }}
            </div>
          </div>
        </template>
        <template #default>
          <div>
            <div class="top-cont-text">
              <div class="left">运输单位：</div>
              <div class="right">
                {{ logisValue.split("(")[0] }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">车号：</div>
              <div class="right">
                {{ item.license_plate }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">司机：</div>
              <div class="right">
                {{ item.name }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">电话：</div>
              <div class="right">
                {{ item.contact }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">预约时间：</div>
              <div class="right">
                {{ formatBookingTime(item.booking_day) }}
                {{ item.begin_time }}-{{ item.end_time }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">发运进度：</div>
              <div class="right colorGreenDark">
                {{
                  item.loading_state === 0
                    ? queueState[item.queue_state]
                    : loadState[item.loading_state]
                }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">进厂时间：</div>
              <div class="right">
                {{ formatTime(item.into_factory_time) }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">开始装车时间：</div>
              <div class="right">
                {{
                  item.loading_time > 0 ? formatTime(item.loading_time) : "--"
                }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">完成装车时间：</div>
              <div class="right">
                {{
                  item.end_loading_time > 0
                    ? formatTime(item.end_loading_time)
                    : "--"
                }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">完成交单时间：</div>
              <div class="right">
                {{
                  item.complete_time > 0 ? formatTime(item.complete_time) : "--"
                }}
              </div>
            </div>
            <div class="top-cont-text">
              <div class="left">装车总耗时：</div>
              <div class="right">
                {{
                  item.loading_time > 0
                    ? `${Math.round(item.total_loading_time / 60)}分钟`
                    : "--"
                }}
              </div>
            </div>
          </div>
        </template>
      </van-collapse-item>
    </van-collapse>
    <Empty v-if="vehicleList.length == 0" style="margin-top: 60px;"></Empty>
  </div>
</template>
<script>
import moment from "moment";
import Empty from "@/components/tips/Empty.vue";
export default {
  data() {
    return {
      page: 1,
      active: "1",
      showCalendar: false,
      timeRange: [],
      pickerShow1: false,
      pickerShow2: false,
      comColumns: [],
      logisColumns: [],
      comValue: "",
      logisValue: "",
      vehicleList: [],
      // {
      //   classTitle: "title",
      //   classTitleLeft: "title-left",
      //   classIcon: "rightIcon"
      // }
      activeNames: ["0"],
      rotate: false,
      params: {
        areaId: "", // 厂区id
        // unitId: "", // 单位id
        unit_full_name: "", // 单位全称
        begin_date: "",
        end_date: ""
      },
      queueState: [
        "",
        "排队中",
        "叫号中",
        "已过号",
        "已失效",
        "已完成",
        "已终止"
      ],
      queueColor: [
        "",
        "color: '#008B5E';",
        "color: '#008B5E'",
        "color: '#EC3F67'",
        "color: '#666666'",
        "color: '#008B5E'",
        "color: '#EC3F67'"
      ],
      loadState: [
        "未开始",
        "等待装货",
        "拒绝装货",
        "装货中",
        "装货完成",
        "已完成",
        "拒绝装车离厂"
      ],
      loadColor: [
        "",
        "color: '#008B5E'",
        "color: '#EC3F67'",
        "color: '#008B5E'",
        "color: '#008B5E'",
        "color: '#008B5E'",
        "color: '#EC3F67'"
      ],
      minDate: new Date(moment().year() - 5, 0, 1),
      maxDate: new Date(moment().year() + 10, 0, 1)
    };
  },
  components: {
    Empty
  },
  computed: {
    // activeClass() {
    //   if (this.timeRange.length > 0) {
    //     return "hideTabActive";
    //   } else {
    //     return "";
    //   }
    // }
  },
  methods: {
    clickTimeTab(label, title) {
      console.log(label, title);
      this.active = label;
      this.timeRange = [];
      // 0 昨天 1 今天
      if (Number(label) === 0) {
        this.params.begin_date = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        this.params.end_date = moment()
          .subtract(1, "days")
          .format("YYYY-MM-DD");
      } else if (Number(label) === 1) {
        this.params.begin_date = moment()
          .startOf("day")
          .format("YYYY-MM-DD");
        this.params.end_date = moment()
          .startOf("day")
          .format("YYYY-MM-DD");
      }
      this.timeRange = [];
      this.getCooperateList();
    },

    onConfirm(val) {
      this.timeRange = [];
      this.timeRange.push(moment(val[0]).format("YYYY/MM/DD"));
      this.timeRange.push(moment(val[1]).format("YYYY/MM/DD"));
      this.params.begin_date = moment(val[0])
        .startOf("day")
        .format("YYYY-MM-DD");
      this.params.end_date = moment(val[1])
        .startOf("day")
        .format("YYYY-MM-DD");
      this.showCalendar = false;
      this.getCooperateList();
    },

    // 选择厂区
    onConfirmCom(val) {
      console.log(val);
      this.comValue = val.text;
      this.pickerShow1 = false;
      this.params.areaId = val.id;
      this.getCooperateList();
    },

    // 选择单位
    onConfirmLogis(val) {
      this.pickerShow2 = false;
      this.logisValue = val.text;
      this.params.unit_full_name = val.unit_full_name;
      if (val.unit_full_name === "") {
        return false;
      } else {
        this.getVehicleList();
      }
    },

    // 格式化日历显示
    formatter(day) {
      if (day.type === "start") {
        day.bottomInfo = "";
      } else if (day.type === "end") {
        day.bottomInfo = "";
      } else {
        day.bottomInfo = "";
      }
      return day;
    },

    // 快捷选择日期
    setTime(tag) {
      this.timeRange = [];
      let end = new Date();
      let start = new Date();
      if (tag === 0) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      } else if (tag === 1) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      } else if (tag === 2) {
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      }
      this.timeRange.push(moment(start).format("YYYY/MM/DD"));
      this.timeRange.push(moment(end).format("YYYY/MM/DD"));
      this.showCalendar = false;
      this.params.begin_date = moment(start).format("YYYY-MM-DD");
      this.params.end_date = moment(end).format("YYYY-MM-DD");
      this.getCooperateList();
    },

    // 格式化预约时间
    formatBookingTime(str) {
      let str1 = String(str);
      if (moment().year() === Number(str1.substring(0, 4))) {
        return `${str1.substring(4, 6)}月${str1.substring(6, 8)}日`;
      } else {
        return `${str1.substring(0, 4)}年
          ${str1.substring(4, 6)}月
          ${str1.substring(6, 8)}日`;
      }
    },

    // 格式化时间
    formatTime(str) {
      let colYear = Number(moment(Number(str) * 1000).format("YYYY"));
      if (moment().year() === colYear) {
        return moment(Number(str) * 1000).format("MM月DD日 HH:mm");
      } else {
        return moment(Number(str) * 1000).format("YYYY年MM月DD日 HH:mm");
      }
    },

    // 切换折叠面板
    changeCollapse(activeNames) {
      console.log(activeNames);
      this.rotate = !this.rotate;
    },

    async getAreaList() {
      await this.$common
        .http({
          url: "/api/queue/summary/list_com"
        })
        .then(res => {
          console.log(res.data.data);
          res.data.data.forEach(item => {
            this.comColumns.push({
              text: item.name,
              id: item.id
            });
          });
          this.comValue = this.comColumns[0].text;
          this.params.areaId = this.comColumns[0].id;
          this.getCooperateList(); // 获取合作单位
          // this.getVehicleList(); // 获取车辆列表
        });
    },

    getCooperateList() {
      this.logisColumns = [];
      this.logisValue = "";
      this.vehicleList = [];
      this.$common
        .http({
          url: "/api/queue/summary/query_unit",
          data: {
            com_id: this.params.areaId,
            // com_id: "ebrbtfhvbgwj90snu4sp5lhp4tulxf67",
            begin_date: this.params.begin_date,
            end_date: this.params.end_date
          }
        })
        .then(res => {
          console.log(res.data);
          if (res.data.data.length > 0) {
            res.data.data.forEach(item => {
              this.logisColumns.push({
                text:
                  item.short_name === ""
                    ? `${item.full_name}(${item.car_number})`
                    : `${item.short_name}(${item.car_number})`,
                unit_full_name: item.full_name
              });
            });
          } else {
            this.logisColumns.push({
              text: "暂无数据",
              disabled: true,
              unit_full_name: ""
            });
          }
          this.logisValue = this.logisColumns[0].text;
          this.params.unit_full_name = this.logisColumns[0].unit_full_name;
          this.getVehicleList();
        });
    },

    getVehicleList() {
      this.vehicleList = [];
      this.$common
        .http({
          url: "/api/queue/summary/list_car_detail",
          data: {
            com_id: this.params.areaId,
            unit_full_name: this.params.unit_full_name,
            begin_date: this.params.begin_date,
            end_date: this.params.end_date
          }
        })
        .then(res => {
          console.log(res.data.data);
          this.vehicleList = res.data.data;
        });
    }
  },
  created() {},
  mounted() {
    this.params.begin_date = moment()
      .startOf("day")
      .format("YYYY-MM-DD");
    this.params.end_date = moment()
      .startOf("day")
      .format("YYYY-MM-DD");
    this.getAreaList();
    // this.comValue = this.comColumns[0];
    // this.logisValue = this.logisColumns[0];
  }
};
</script>
<style lang="less" scoped>
.statisDiv {
  min-height: calc(100vh - 1px);
  background: #f4f5f6;
  font-size: 16px;
  .top-cont {
    display: flex;
    background: #fff;
    .time {
      flex: 1.7;
      font-size: 12px;
      line-height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #9b9b9b;
      height: 25px;
      margin-top: 9px;
      background: #f4f5f6;
      margin: 9px 15px 0px 11px;
    }
  }
  .cont1 {
    display: flex;
    & > div {
      flex: 1;
    }
    .blk {
      background: #fff;
      display: flex;
      margin: 10px 0px;
      border-right: 1px solid #f4f5f6;
      justify-content: center;
      align-items: center;
      height: 46px;
      .left {
        // flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        width: calc(50vw - 85px);
      }
      .right {
        flex: 0.5;
        text-align: right;
        margin-top: 4px;
      }
    }
  }
  .top-cont-text {
    padding: 0px 0px 14px;
    background: #fff;
    font-size: 16px;
    display: flex;
    .left {
      // display: inline-block;
      // width: calc(33vw - 5px);
      flex: 1;
      text-align: right;
      margin-right: 15px;
      vertical-align: top;
      color: #b2b2b2;
    }
    .right {
      // display: inline-block;
      // width: calc(63vw - 30px);
      flex: 1.6;
      vertical-align: top;
      word-break: break-all;
      color: #000;
    }
  }
  .colorB2 {
    color: #b2b2b2;
  }
  .rightIcon {
    font-size: 19px;
    padding: 8px 0px 0px 0px;
  }
  .title {
    padding: 8px 0px 8px 0px;
    font-size: 16px;
  }
  .title-left {
    display: inline-block;
    background: #e5f3ee;
    padding: 1px 10px;
    color: #008b5e;
    margin-left: 14px;
  }
  .title-left-span {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
    max-width: 30vw;
    vertical-align: middle;
  }
  .first {
    transition: all 1s;
  }

  .second {
    transform: rotate(-90deg);
    transition: all 1s;
  }
  .calendar-cont {
    height: 36px;
    font-size: 14px;
    display: flex;
    text-align: center;
    align-items: center;
    justify-content: center;
    color: #009967;
    background: #f7f7f7;
    box-shadow: 0px 2px 20px rgba(125, 126, 128, 0.16);
  }
}
</style>
<style lang="less">
.statisDiv {
  .van-tab {
    font-size: 16px;
  }
  .hideTabActive {
    .van-tabs__line {
      background-color: #fff !important;
    }
    .van-tab--active {
      color: #b2b2b2 !important;
    }
  }
}
.van-button--round {
  border-radius: 4px;
}
.van-search {
  background-color: inherit;
}
.van-search__content {
  background-color: #fff;
}
.van-search .van-cell {
  padding: 1px 8px 1px 0;
  font-size: 13px;
}
.van-collapse-item {
  margin-bottom: 10px;
}
.van-cell--clickable {
  padding: 7px 16px;
}
#static .van-cell__right-icon {
  line-height: 42px;
}
#vehicleModify .van-calendar__popup.van-popup--left,
.van-calendar__popup.van-popup--right {
  height: 52vh;
  margin: 0px 30px;
}
#vehicleModify .van-calendar__footer {
  padding: 0px;
}
</style>
